// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-DownloadButtonBar_cls1__YYKVK","cls2":"StyledComponents-DownloadButtonBar_cls2__Kt31j StyledComponents-DownloadButtonBar_cls1__YYKVK"};